import React from "react";
import './success-tick.styles.scss';

const SuccessTick = () => {

    return (
        <div>
            <i className="material-icons check-icon">check</i>
        </div>
    );
};

export default SuccessTick;